const initialState = {};

export default function newTaskDataReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
